import { generatePath } from 'react-router-dom';

import { VirtualCatalog } from '@components/catalog/VirtualCatalog';
import { edgesToProducts } from '@utils/products';
import { useFilterData } from '@hook/productFilters';
import { virtualCatalog } from '@urls';
import { PageMetaTitle } from '@components/PageMetaTitle';
import { PageMetaDescription } from '@components/PageMetaDescription';

import {
  useVirtualCatalogProductsQuery,
  useVirtualCatalogQuery,
} from './graphql.v3.generated';

type VirtualCatalogContaineProps = {
  slug: string
  className?: string
};

export const VirtualCatalogContainer: React.FC<VirtualCatalogContaineProps> = ({
  slug,
  className,
}) => {
  const { filters } = useFilterData();
  const { data, loading } = useVirtualCatalogQuery({
    variables: { slug },
    fetchPolicy: 'network-only',
  });
  const {
    data: productsData,
    loading: productsLoading,
    fetchMore,
  } = useVirtualCatalogProductsQuery({
    variables: {
      slug,
      ...filters,
      ukrainian: !!filters.ukrainian,
      priceId: filters.prices,
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });

  if (!data || !productsData) {
    return null;
  }

  const {
    title,
    seoTitle,
    seoDescription,
    seoMetaDescription,
    breadcrumbs,
    siblings,
    linkedCatalogs,
  } = data.virtualCatalog;
  const { products } = productsData.virtualCatalog;

  const onLoadMore = async () => {
    if (products.pageInfo.hasNextPage) {
      if (products?.edges) {
        await fetchMore({
          variables: {
            after: products.pageInfo.endCursor,
          },
        });
      }
    }
  };
  return (
    <>
      <PageMetaTitle title={seoTitle} />
      <PageMetaDescription description={seoMetaDescription} />

      <VirtualCatalog
        className={className}
        title={title}
        products={edgesToProducts(products.edges)}
        hasNextPage={products.pageInfo.hasNextPage}
        loading={loading || productsLoading}
        categories={products.topLevelCategories || null}
        total={products.pageInfo.total || 0}
        onLoadMore={onLoadMore}
        mostFrequentCatalogSlug={products.mostFrequentCatalogSlug}
        seoDescription={seoDescription}
        breadcrumbs={breadcrumbs.map(
          (breadcrumb) => ({
            title: breadcrumb.title,
            url: generatePath(virtualCatalog, { virtualCatalogSlug: breadcrumb.slug }),
          }),
        )}
        siblings={siblings.map(
          (breadcrumb) => ({
            id: String(breadcrumb.id),
            name: breadcrumb.title,
            url: generatePath(virtualCatalog, { virtualCatalogSlug: breadcrumb.slug }),
          }),
        )}
        linkedCatalogs={linkedCatalogs}
      />
    </>

  );
};
